import { BallPointPenAction } from '../../../core/actions/ballpoint_pen/ballpoint_pen_action';
import { LampEasySearchAction } from '../../../core/actions/lamp/lamp_search_action';
import { OrangeBookAction } from '../../../core/actions/orange_book/orange_book_action';
import { Env } from '../../../core/env';
import { TonerAction } from '../../../core/actions/toner/toner_action';
import { CategorySAction } from '../actions/category_s_action';
import { ItemRefineSearchAction } from '../../../core/actions/item_refine_search/item_refine_search_action';
import { SearchResultEnqueteAction } from '../../../core/actions/search_result_enquete/search_result_enquete_action';
import { AddRecommendationItemAction } from '../../addRecommendationItem/actions/add_recommendation_item_action';
import { AddRecommendationItemContainer } from '../../addRecommendationItem/views/pc/add_recommendation_item_container';
import { ComparisonTableAction } from '../../../core/actions/comparison_table/comparison_table_action';
import { BulkAddCartAction } from '../../../core/actions/add_cart/bulk_add_cart_action';
import { CouponModalAction } from '../../../core/actions/coupon/coupon_modal_action';

document.addEventListener('DOMContentLoaded', () => {
  CategorySAction.init(Env);
  TonerAction.init();
  LampEasySearchAction.init();
  BallPointPenAction.init();
  ItemRefineSearchAction.init(Env);
  SearchResultEnqueteAction.init(Env);
  AddRecommendationItemAction.init(Env, AddRecommendationItemContainer);
  OrangeBookAction.init();

  // 比較表
  ComparisonTableAction.init(Env);

  // クーポンモーダル
  CouponModalAction.init(Env);

  // 共通スペックモーダル一括カゴ投入ボタン初期化
  BulkAddCartAction.init({
    bulkAddCartButtonsClass: 'variation-common-specs-modal-bulk-add-cart-button'
  });
});
